import React from 'react';
import './Hero.css';

function Hero() {
  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <div className="relative bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 lg:py-16">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 pb-16 sm:pb-20">
          {/* Left Column */}
          <div className="w-full md:[width:clamp(38%,42%-0.2*100vw,48%)]">
            <h1 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-primary-700 mb-4">
              <span className="relative inline-block">
                <span className="relative z-10">Protect Your Family</span>
                <div className="absolute -bottom-2 left-0 w-full h-3 bg-secondary-100/40 -rotate-1 -z-[1]" />
              </span>{' '}
              <span>With a Complete Estate Plan</span>
            </h1>

            <p className="mt-3 text-secondary-500 text-sm sm:text-base lg:text-lg">
              Create your trust, will, and powers of attorney from the comfort
              of home — backed by attorney review.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <a
                href="https://app.trustbuilder.law"
                className="px-6 py-3 md:px-8 md:py-4 rounded-md font-medium text-white
                           bg-gradient-to-r from-primary-600 to-primary-500
                           hover:from-primary-700 hover:to-primary-600
                           shadow-[0_8px_16px_-6px_rgba(0,0,0,0.2)]
                           hover:shadow-[0_12px_20px_-8px_rgba(0,0,0,0.3)]
                           transition-all duration-200 text-center"
              >
                Get Started
              </a>
              <a
                href="#benefits-section"
                onClick={(e) => scrollToSection(e, 'benefits-section')}
                className="px-6 py-3 md:px-8 md:py-4 rounded-md font-medium text-primary-600
                           bg-white/80 border border-primary-600/20
                           hover:bg-primary-50/80
                           shadow-[0_4px_12px_-6px_rgba(0,0,0,0.1)]
                           hover:shadow-[0_8px_16px_-8px_rgba(0,0,0,0.2)]
                           transition-all duration-200 text-center"
              >
                See Features
              </a>
            </div>
          </div>

          {/* Right Column */}
          <div className="w-full mt-12 md:mt-0
                        md:[width:clamp(52%,58%+0.2*100vw,62%)]
                        md:[margin-right:clamp(-1rem,-2rem-0.15*100vw,-10rem)]"
          >
            <div className="relative w-full" style={{ perspective: '1500px' }}>
              <div className="absolute -inset-8 bg-gradient-to-r from-transparent via-secondary-200/30 to-primary-100/30 blur-2xl rounded-xl" />
              <div className="absolute -inset-4 bg-gradient-to-r from-transparent via-secondary-100/20 to-primary-200/20 blur-lg rounded-xl" />
              <img
                className="w-full h-auto rounded-xl floating-screenshot relative z-10"
                src="/screenshot2.png"
                alt="TrustBuilder platform interface"
                loading="eager"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero; 